"use client"

import * as React from "react"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const FUNNEL_COLORS = [
    '#E74C3C',
    '#F39C12',
    '#F1C40F',
    '#9B59B6',
    '#3498DB',
    '#1ABC9C',
    '#2ECC71',
    '#E67E22',
    '#1F77B4',
    '#8E44AD',
];

function FunnelStep({ item, index, total, maxValue, totalSteps }) {
    const widthPercent = maxValue > 0 ? (item.total / maxValue) * 100 : 0;
    const minWidth = 15;
    const width = Math.max(widthPercent, minWidth);
    const color = FUNNEL_COLORS[index % FUNNEL_COLORS.length];

    const isFirst = index === 0;
    const isLast = index === totalSteps - 1;

    const nextItem = index < totalSteps - 1 ? total[index + 1] : null;
    const conversionRate = nextItem && item.total > 0
        ? ((nextItem.total / item.total) * 100).toFixed(1)
        : null;

    return (
        <div className="flex items-center gap-3 group">
            <div className="flex-1 flex justify-center">
                <div
                    className="relative flex items-center justify-center transition-all duration-300 group-hover:scale-[1.02]"
                    style={{
                        width: `${width}%`,
                        minWidth: '80px',
                        height: '48px',
                        background: color,
                        clipPath: isLast
                            ? 'polygon(8% 0%, 92% 0%, 50% 100%, 50% 100%)'
                            : `polygon(0% 0%, 100% 0%, ${50 + (width * 0.45)}% 100%, ${50 - (width * 0.45)}% 100%)`,
                        borderRadius: isFirst ? '6px 6px 0 0' : '0',
                    }}
                >
                    <span className="text-white font-bold text-sm z-10 drop-shadow-sm">
                        {item.total}
                    </span>
                </div>
            </div>
            <div className="w-[140px] flex flex-col">
                <span className="text-xs font-semibold text-gray-700 truncate">{item.nome}</span>
                {conversionRate && (
                    <span className="text-[10px] text-gray-400">{conversionRate}% →</span>
                )}
            </div>
        </div>
    );
}

export function GraficoFunilConversao({ chartData }) {
    const maxValue = chartData?.length > 0 ? Math.max(...chartData.map(d => d.total)) : 0;

    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <CardTitle>Funil de conversão</CardTitle>
                    <CardDescription>Visualização do funil com taxa de conversão entre etapas</CardDescription>
                </div>
            </CardHeader>
            <CardContent className="pt-4">
                {!chartData || chartData.length === 0 ? (
                    <EmptyContentGhost />
                ) : (
                    <div className="flex flex-col gap-0.5 py-2">
                        {chartData.map((item, index) => (
                            <FunnelStep
                                key={item.nome || index}
                                item={item}
                                index={index}
                                total={chartData}
                                maxValue={maxValue}
                                totalSteps={chartData.length}
                            />
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    )
}
